import { Lightbulb } from "lucide-react";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import type { TextIntroBodyData } from "@/types/storyboard";

interface Props {
  data: TextIntroBodyData;
  title: string;
}

export const TextHint = ({ data, title }: Props) => {
  const heading = data.title || title;

  return (
    <div className="rounded-2xl border border-accent bg-accent px-6 py-8">
      <div className="mb-4 flex items-center gap-3">
        <div
          className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-primary bg-white"
          aria-hidden="true"
        >
          <Lightbulb className="size-5 text-primary" />
        </div>
        {heading && <h2>{heading}</h2>}
      </div>
      <div className="prose max-w-full text-primary font-semibold">
        {data.introduction && (
          <CourseMarkdown>{data.introduction}</CourseMarkdown>
        )}
        {data.text && <CourseMarkdown>{data.text}</CourseMarkdown>}
      </div>
    </div>
  );
};
